<template>
  <div class="maintainance-page-wrapper">
    <b-icon
      icon="cogs"
      type="is-dark"
      class="maintainance-icon"
      size="is-large"
      custom-size="mdi-48px"
    >
    </b-icon>
    <h2>Website under maintainance</h2>
    <p>
      New Item application is currently under scheduled maintainance from 7AM to
      9 AM EST. Please clear your cache and check again after 9 AM EST.
    </p>
  </div>
</template>

<script>
export default {
  name: "MaintainancePage"
};
</script>

<style scoped></style>
